import type { InputState } from '#/global/component/Form/types'

interface Props {
    formWidth?: string
    state: InputState
}

export const State = ({ formWidth, state }: Props) => {
    return <div className={`input-${state.level} ${formWidth || ''}`}>{state.message}</div>
}
